var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l1 = _vm.__map(_vm.dataList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g0 =
      item.type === 0 && item.status === 5 && item.overdueStatus === 1
        ? ((item.overdueFee || 0) / 100).toFixed(2)
        : null
    var g1 =
      item.type === 0 && item.status === 5 && item.overdueStatus === 3
        ? ((item.overdueFee || 0) / 100).toFixed(2)
        : null
    var g2 =
      !(item.type === 0) && item.status === 5 && item.overdueStatus === 1
        ? ((item.overdueFee || 0) / 100).toFixed(2)
        : null
    var g3 =
      !(item.type === 0) && item.status === 5 && item.overdueStatus === 3
        ? ((item.overdueFee || 0) / 100).toFixed(2)
        : null
    var l0 = item.detailList
      ? _vm.__map(item.detailList, function (goods, __i1__) {
          var $orig = _vm.__get_orig(goods)
          var g4 = ((goods.subtotal || 0) / 100).toFixed(2)
          return {
            $orig: $orig,
            g4: g4,
          }
        })
      : null
    var g5 = ((item.estimatedAmount || 0) / 100).toFixed(2)
    var g6 = ((item.declaredFee || 0) / 100).toFixed(2)
    var g7 = [1, 4].includes(item.status) && item.takeShopId
    return {
      $orig: $orig,
      g0: g0,
      g1: g1,
      g2: g2,
      g3: g3,
      l0: l0,
      g5: g5,
      g6: g6,
      g7: g7,
    }
  })
  var g8 = !_vm.loading ? !_vm.hasNext && _vm.dataList.length : null
  var g9 = !_vm.loading && !g8 ? !_vm.hasNext && !_vm.dataList.length : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, item) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        item = _temp2.item
      var _temp, _temp2
      _vm.activeTab = item.value
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l1: l1,
        g8: g8,
        g9: g9,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }